import { render } from "./ShippingMethod.vue?vue&type=template&id=2535fe8c"
import script from "./ShippingMethod.js?vue&type=script&lang=js"
export * from "./ShippingMethod.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__